import { SHOW_MODAL, MODAL_CONFIRM, MODAL_CANCEL, HIDE_MODAL } from '../action_types/modals';

function modals_reducer(state = {}, action) {
  switch (action.type) {
    case SHOW_MODAL:
      if (!action.modal_name) {
        console.error('modal reducer: cannot show modal with no modal name');
      }
      return Object.assign({}, state, {
        [action.modal_name]: Object.assign({}, state[action.modal_name], {
          visible: true,
          modal_state: 'open',
        }),
      });

    case MODAL_CONFIRM:
      if (!action.modal_name) {
        console.error('modal reducer: cannot confirm modal with no modal name');
      }
      return Object.assign({}, state, {
        [action.modal_name]: Object.assign({}, state[action.modal_name], {
          modal_state: 'success',
          confirm_value: action.value,
        }),
      });

    case MODAL_CANCEL:
      if (!action.modal_name) {
        console.error('modal reducer: cannot cancel modal with no modal name');
      }
      return Object.assign({}, state, {
        [action.modal_name]: Object.assign({}, state[action.modal_name], {
          modal_state: 'cancel',
          cancel_value: action.value,
        }),
      });

    case HIDE_MODAL:
      if (!action.modal_name) {
        console.error('modal reducer: cannot hide modal with no modal name');
      }
      return Object.assign({}, state, {
        [action.modal_name]: Object.assign({}, state[action.modal_name], {
          visible: false,
        }),
      });
  }

  return state;
}

export default modals_reducer;
